import React from 'react';
import { Table, Card, Title, createStyles, Text, Stack } from '@mantine/core';
import { randomString } from '../../utils';

const useStyles = createStyles((theme) => ({
  table: {
    tableLayout: 'fixed',
  },
  cell: {
    padding: '0.25rem !important',
  },
  freeSpace: {
    background: theme.colors.gray[0],
  },
  inner: {
    aspectRatio: '1 / 1',
  }
}));

function DemoCard(props) {
  const { classes } = useStyles();
  const {
    game,
    tracks,
    transitionStyles,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  } = props;

  const {
    title,
    titleStyle,
    freeSpace,
  } = game;  

  const textProps = {
    ta: 'center',
    c: 'dimmed',
    fz: 8,
    lh: 1.15,
    lts: -0.15,
  };

  const isFreeSpace = (rowIdx, trackIdx) => rowIdx === 2 && trackIdx === 2;

  const getFreeSpace = () => {
    const Icon = freeSpace.icon;

    return <>
      <Icon
        size={24}
        color={freeSpace.color}
        strokeWidth={1}
      />
      <Text
        ta='center'
        c='dimmed'
        fw={600}
        fz={8}
        lh={1.15}
        lts={-0.15}
      >
        {freeSpace.text}
      </Text>
    </>
  };

  const getCell = (track) => <>
    <Text {...textProps} fw={500}>{track.name}</Text>
    <Text {...textProps}>{track.artist}</Text>
  </>;

  const getRows = (trackList) => trackList.map((row, rowIdx) => (
    <tr key={randomString()}>
      {row.map((track, trackIdx) =>          
        <td className={`${classes.cell} ${isFreeSpace(rowIdx, trackIdx) && classes.freeSpace}`} key={randomString()}>
          <Stack className={classes.inner} justify='center' align='center' spacing={4}>
            {isFreeSpace(rowIdx, trackIdx) ? getFreeSpace() : getCell(track)}
          </Stack>
        </td>
      )}
    </tr>
  ));

  return (
    <Card
      shadow='lg'
      radius='md'
      style={transitionStyles}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
    <Title align='center' order={3} mb='md' fw={400} style={titleStyle}>{title}</Title>
      <Table style={{ pointerEvents: 'none' }} verticalSpacing='xs' fontSize='xs' withBorder withColumnBorders className={classes.table}>
        <tbody>
          {getRows(tracks)}
        </tbody>
      </Table>
    </Card>
  )
}

export default DemoCard;